module.exports = __webpack_public_path__ + "static/img/202302.a59b26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202302.png
// module id = 2cE2
// module chunks = 0